import type { NextPage } from 'next'
import { ShippingOptions } from '@/client/modules/ShippingOptions'
import { ShippingOptionsProps } from '@/client/modules/ShippingOptions/types'
import { getCMSContent } from '@/client/utils'

const ShippingOptionsPage: NextPage<ShippingOptionsProps> = (data) => <ShippingOptions {...data} />

export async function getStaticProps({ defaultLocale, locale }) {
  const data = await getCMSContent(defaultLocale, locale, 'DELIVERY_SHIPPING')

  if (!data?.content) return { revalidate: 60, notFound: true }

  return {
    revalidate: 10,
    props: { ...data }
  }
}

export default ShippingOptionsPage
